import { logger } from "~/utils/logger";

export default defineNuxtRouteMiddleware(async (to, from) => {
  // Only run on client side
  if (process.server) return;

  // Check if we're in a popup window
  const isPopup =
    (window.opener && !window.opener.closed) || window.name === "oauth_popup";

  if (!isPopup) return;

  logger.log("🎯 POPUP DETECTED in middleware");

  // We're in a popup! Wait a bit for auth to be restored
  await new Promise((resolve) => setTimeout(resolve, 300));

  const authStore = useAuthStore();

  // Try to restore session if not already done
  if (!authStore.sessionRestored) {
    logger.log("📡 Restoring session in popup...");
    await authStore.restoreSession();
  }

  logger.log("🔍 Popup auth check:", {
    isAuthenticated: authStore.isAuthenticated,
    verificationRequired: authStore.verificationRequired,
    user: authStore.user?.email,
  });

  if (authStore.isAuthenticated) {
    logger.log("🎯 POPUP + AUTHENTICATED - Checking verification status...");

    // Check if email verification is required
    logger.log(
      "📋 authStore.verificationRequired =",
      authStore.verificationRequired
    );

    if (authStore.verificationRequired) {
      logger.log(
        "⚠️ Email verification required - will navigate to /verification"
      );
      logger.log("🏷️ SETTING from_registration flag in localStorage");
      localStorage.setItem("from_registration", "true");
      logger.log(
        "✅ Flag set successfully, value:",
        localStorage.getItem("from_registration")
      );

      // DON'T close the popup yet - let it navigate to /verification
      // The verification page will close the popup after successful verification
      logger.log("ℹ️ Letting popup continue to verification page...");

      // Send message to parent to let it know verification is needed
      if (window.opener && !window.opener.closed) {
        try {
          window.opener.postMessage(
            { type: "oauth_success", session: authStore.user },
            window.location.origin
          );
          logger.log("✅ Message sent to parent");
        } catch (e) {
          logger.error("❌ Failed to send message:", e);
        }
      }

      // Return without closing - let the flow continue to /verification
      return;
    } else {
      logger.log(
        "ℹ️ No verification required - user email is already verified"
      );
    }

    logger.log("🎯 Closing popup now!");

    // Send message to parent
    if (window.opener && !window.opener.closed) {
      try {
        window.opener.postMessage(
          { type: "oauth_success", session: authStore.user },
          window.location.origin
        );
        logger.log("✅ Message sent to parent");
      } catch (e) {
        logger.error("❌ Failed to send message:", e);
      }
    }

    // Close immediately
    window.close();

    // Keep trying to close
    let attempts = 0;
    const interval = setInterval(() => {
      window.close();
      attempts++;
      if (attempts > 20) {
        clearInterval(interval);
        alert("Connexion réussie! Veuillez fermer cette fenêtre.");
      }
    }, 100);

    // Prevent navigation
    return abortNavigation();
  } else {
    logger.log("⚠️ Popup detected but not authenticated yet");
  }
});
